export default __webpack_public_path__ + "static/media/unicred-logo.39552f6e.png";